import React from 'react';
import { navigate, getEnv } from '@/common/agents';
import Button from '$/components/base/Button';
import useThemeStore from '$/store/useThemeStore';
import img from './404.png';
import imgLight from './404Light.png';
import styles from './index.module.scss';

function NotFound() {
  const theme = useThemeStore((state) => state.theme);
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.box}>
          <img className={styles.img} src={theme === 'light' ? imgLight.src : img.src} alt="404" />
          <span className={styles.text}>页面已丢失…</span>
        </div>
        <Button
          className={styles.btn}
          type="default"
          onClick={() => {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
              replace: true,
            });
          }}
        >
          回到首页
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
